import { render, staticRenderFns } from "./Report4.vue?vue&type=template&id=2b5ac5d6&"
import script from "./Report4.vue?vue&type=script&lang=js&"
export * from "./Report4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports